// Recovery Potential — score → reversibility star rating. Shared between the
// on-page result card (Assessment.jsx) and the downloadable PDF report so the
// star rating is identical everywhere.
//
// Score band  Stars   Label
// 0-40        5       Excellent
// 41-60       4       Very Good
// 61-80       4       Good
// 81-100      3       Fair
//
// When `band` is "red" (e.g., a Medical Red Flag has overridden the score),
// we force the lowest tier (Fair · 3 stars) regardless of the raw score,
// because reversibility is genuinely limited when a red flag is present.
export function recoveryPotential(score, band) {
  if (band === "red") return { stars: 3, label: "Fair" };
  const s = Number(score);
  if (!Number.isFinite(s)) return null;
  if (s <= 40) return { stars: 5, label: "Excellent" };
  if (s <= 60) return { stars: 4, label: "Very Good" };
  if (s <= 80) return { stars: 4, label: "Good" };
  return { stars: 3, label: "Fair" };
}
